import { getResponse } from 'services/api';

// Fetches the raw (un-substituted) Handlebars HTML of the date-change email template from the backend
// (single source of truth with the send path). The caller compiles it with handlebars + the same
// template-data keys the backend emits, so the preview matches the real email.
export const getDateChangeEmailTemplate = async (): Promise<string> => {
	const response = await getResponse('/events/date-change-template');
	return response.data as string;
};
